import { logger } from 'shared/lib'
import type { IEntitiesStore } from 'entities/EntitiesExport'

export function getAppData(entities: IEntitiesStore) {
  const notBlockerRequest = [
    entities.usersStore.init,
    entities.organizationStore.init,
    entities.billingStore.fetchBillingStates,
    entities.subscriptionStore.init,
    entities.userPermissionsStore.fetchUserPermissions,
    entities.usersStore.fetchUsersBusinessHours,
    entities.usersStore.initUsersOrganization,
    entities.configStore.init,
    entities.userSettingsStore.fetchUsersSettings,
    entities.featureFlagsStore.fetchFeatureFlags,
    entities.multiOrganizationStore.fetchMultiOrganizations,
    entities.attachmentStore.loadUploadInfo,
    entities.organizationSettingsStore.fetchOrganizationSettings,
    entities.numbersStore.fetchOrganizationNumber,
    entities.numbersStore.fetchNumberVendorIntegrations,
    entities.numbersStore.fetchNumbers,
    entities.billingStore.fetchAutorecharge,
    entities.billingStore.applyCoupon,
    entities.billingStore.fetchBillingAreaCodes,
    entities.complianceStore.fetchSummary,
    entities.complianceStore.fetchOrganizationBusinessProfile,
    entities.complianceStore.fetchComplianceServicesList,
    entities.complianceStore.fetchOrganizationTollFree,
    entities.integrationsStore.fetchIntegrations,
    entities.rcsStore.init,
  ]

  Promise.all(notBlockerRequest.map((req) => req())).catch(logger.error)
}
